import styled, { css } from 'vue-styled-components'

const ImageCropWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 500;
`
const ImageStopRegion = styled.div`
    position: absolute;
    background-color: #0000002e;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    `
const ImageFrameProps = {
  data: {},
  config: {},
  disableCropResize: Boolean,
  is_stretch_height: Boolean
}
const getImageShape = ({ shape }) => {
  switch (shape) {
    case 'rounded':
      return css`border-radius: 15px;`
    case 'circle':
      return css`border-radius: 50%;`
    default:
      return '';
  }
}
const ImageFrame = styled('div', ImageFrameProps)`
    ${({ config }) => getImageShape(config)}
    outline: ${({ disableCropResize }) => disableCropResize ? `1px solid #50565D ` : `1px solid #12A9FF`};
    position: absolute;
    pointer-events: none;
    background-repeat: no-repeat;
   ;
  
`
const ImageDragAreaProps = {

}
const ImageDragArea = styled('div', ImageDragAreaProps)`
    position: absolute;
    opacity: 0.3;
    cursor: all-scroll;
   
    background-size: 100%;
    outline: 1px solid #fff;
    `
const ImageToolProps = {
  width: Number,
  height: Number,
  alignX: String
}
const ImageTool = styled('div', ImageToolProps)`
  pointer-events: all;
  width: 435px;
  height: 32px;
  position: relative;
  background-color: #FFFFFF;
  border: 1px solid #DEE3E6;
  margin: auto;
  padding: 4px 16px;
  gap: 10px;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15);
  border-radius: 20px;
  &.top {
    top: -50px;
    left: ${({ alignX, width }) => alignX == 'start' ? '217.5px' : (alignX == 'end' ? -(217.5 - width) + 'px' : (width / 2) + 'px')};
    transform: translate(-50%);
  }
  &.left {
    top: ${({ height }) => (height / 2)}px;
    left : ${({ width }) => width < 435 ? -445 : -((width / 2) + 227.5)}px;
  }
  &.right {
    top: ${({ height }) => (height / 2)}px;
    right : ${({ width }) => -(width + 10)}px;
  }
  &.bottom {
    left: 0;
    right: 0;
    bottom : ${({ height }) => -(height + 10)}px;
  }
  &.overscreen {
    top: ${({ height }) => (height / 2)}px;
  }
  .btn-tool:hover {
    svg, .fs-db-20 {
      color: #24BEE2
    }
  }
`
const frameResizeProps = {
  position: {}
}
const FrameResize = styled('div', frameResizeProps)`
position: absolute;
width: 100%;
height: 100%;
top: 0;
&.disabled .resize {
  &.n, &.s,&.w, &.e {
    cursor: not-allowed !important;
    background-color: #50565D !important;
  }
  &.nw, &.se, &.ne, &.sw{
    cursor: not-allowed !important;
    &:after {
      background-color: #50565D !important;
    }
    &:before {
      background-color: #50565D !important;
    }
  }
}
.resize {
  pointer-events: all;
  position: absolute;
  width: ${({ position }) => position.width <= 90 ||  position.height <= 90 ? '15' : '30'}px;
  height: ${({ position }) => position.width <= 90 ||  position.height <= 90 ? '15' : '30'}px;
  &.n, &.s{
    width: ${({ position }) => position.width <= 90 ||  position.height <= 90 ? '15' : '30'}px;
    height: 6px;
    left: 0;
    right: 0;
    margin: auto;
    cursor: ns-resize;
    background-color: #12A9FF;
  }
  &.w, &.e{
    height: ${({ position }) => position.width <= 90 ||  position.height <= 90 ? '15' : '30'}px;
    width: 6px;
    top: 0;
    bottom: 0;
    margin: auto;
    cursor: ew-resize;
    background-color: #12A9FF;
  }
  &.nw, &.se, &.ne, &.sw {
    &:after {
      content: '';
      position: absolute;
      background-color: #12A9FF;
      width: 100%;
      height: 6px;
     }
     &:before {
      content: '';
      position: absolute;
      background-color: #12A9FF;
      width: 6px;
      height: 100%;
     }
  }
  &.nw, &.se {
    cursor: nwse-resize;
    background-color: transparent;
  }
  &.ne, &.sw {
    cursor: nesw-resize;
    background-color: transparent;
  }
  &.n{
   top: 0;
  }
  &.w{
   left: 0;
  }
  &.s{
   bottom: 0;
  }
  &.e{
   right: 0;
  }
  &.nw{
   top: 0 ;
   left: 0;
  }
  &.ne{
   top: 0;
   right: 0;
   &:before {
    right: 0;
   }
  }
  &.sw{
   bottom: 0;
   left: 0;
   &:after {
     bottom: 0;
   }
  }
  &.se{
    bottom: 0;
    right: 0;
    &:after {
      bottom: 0;
     }
     &:before {
      right: 0;
     }
  }
}
`

const SizeDetail = styled.div`
  position: absolute;
  width: fit-content;
  min-width: 86px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #FFFFFF;
  border-radius: 4px;
  padding: 4px 8px;
  top: -18px !important;
  font-family: 'Roboto';
  font-size: 12px;
`
export {
  ImageCropWrapper,
  ImageStopRegion,
  ImageFrame,
  ImageDragArea,
  ImageTool,
  FrameResize,
  SizeDetail
}